import { Grid2, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import { useTranslate } from "../../../../hooks/useTranslate";
import { useStudents } from "../../../../context/students";

export const ITP = () => {
    const { t } = useTranslate();
    const navigate = useNavigate();

    const { activeStudentId } = useStudents();

    return (
        <div className="page-content">
            <div className="student-head-section" />
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }} className="text-white">
                    <Breadcrumbs
                        breadcrumbs={[
                            { label: t("navigation.home"), href: `/home/${activeStudentId}` },
                            { label: t("supportingLearning.title"), href: `/supporting-learning/${activeStudentId}` },
                            { label: t("supportingLearning.itp"), current: true },
                        ]}
                    />
                    <Typography variant="h1" className="text-white">
                        {t("supportingLearning.itp")}
                    </Typography>
                    <Typography variant="body1" className="mt-4 text-white" component="div">
                        {t("supportingLearning.subtitle")}
                    </Typography>
                </Grid2>
            </Grid2>
        </div>
    );
};
